<template>
  <div id="app">
    <div id="tophead" class="flex-center h-9">
      <div class="flex-center  px-4  w-87.5rem">
        <template v-if="!user || !user.id">
          <el-link type="info" :underline="false" @click="sign_dialog = true,type='login'">
            <span class="iconfont icon-qingdenglu text-14px">
              {{
                $t("您好，请登录")
              }}
            </span>
          </el-link>
          <Login :show.sync="sign_dialog" @change="hclick" :type="type"></Login>
          <a style="margin-left: 20px" @click="sign_dialog = true,type='register'" class="cursor-pointer">{{ $t("免费注册") }}</a>
        </template>
        <template v-else>
          <router-link to="/mine/center" class="flex items-center">
            <span class="mr-2">{{ user.name }}</span>
            <img class="img-vip" src="@/assets/image/vip.png" alt />
          </router-link>
          <el-link @click="showAddr" class="ml-4 ">
             <div class="flex items-center">
              <span class="iconfont icon-shouhuodi" style="color: #C9C9C9;">
            </span>
            <span>
              {{ user.address && user.address.id ? user.address.address : $t('请选择地址')}}
            </span>
            <span class="iconfont icon-right"></span>
             </div>
          </el-link>
          <span class="ml-4 cursor-pointer" @click="loginOut">
            {{
              $t("退出")
            }}
          </span>
        </template>
        <span class="flex-1"></span>
        <!-- <a href="https://www.huaeb.com/mall/#/" target="_blank" class="img-link flex items-center">
          <img src="https://cdn-qn.huaeb.com/sellmall/Xhd/20251113/FoL_EVjtcvK3C2S9bROffn_JrQjZ.png" class="w-18px h-18px mr-1"/>
          {{ $t("花易宝中国") }}
        </a>
        <span class="v-line"></span> -->
        <a href="https://www.huaeb.com/" target="_blank"  class="img-link flex items-center">
          <img src="https://cdn-qn.huaeb.com/sellmall/Xhd/20251113/FiIPiFknyULvN3YxwcpHuX8Z5Yyz.png" class="w-18px h-18px mr-1"/>
          {{ $t("花易宝官网") }}   
        </a>
        <span class="v-line"></span>

        <router-link class="cursor-pointer" :to="{ name: 'news', query: { tag: 'news' } }">{{ $t("新闻资讯") }}
        </router-link>
        <span class="v-line"></span>
        <router-link :to="{name:'cusprocess'}">{{ $t("外贸服务") }}</router-link>
        <span class="v-line"></span>
        <router-link class="cursor-pointer" :to="{ name: 'flightList'}">{{ $t("航班查询") }}
        </router-link>
        <span class="v-line"></span>
        <!-- <div class="cursor-pointer">
          <i class="iconfont icon-shoujiban mr-1"></i>
          <a>{{ $t("手机版") }}</a>
        </div>
        <span class="v-line"></span> -->
        <el-popover placement="bottom" width="400" trigger="click">
          <div>
            <div>1{{ maintype.name}} ≈ {{showRate()}}{{ curtype.name }}</div>
            <div>1{{ curtype.name }} ≈ {{showRate(true)}}{{ maintype.name }}</div>
            <div class="rate-box flex-column flex-center">
              <div class="rate flex-between">
                <span class="left">
                  <el-dropdown @command="handleCommandRateMain">
                    <div class="el-dropdown-link flex items-center">
                      <img :src="$smallImage(maintype.icon)" class="type-icon" v-if="maintype && maintype.icon"/>{{maintype.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in nationalData.moneytypes" :key="item.key" :command="item.key">{{ item.name}}
                    </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <span class="right">
                  {{maintype.symbol}}<input v-model="moneyForm.money" @blur="updateMoney" />
                </span>
              </div>
              <div class="iconfont icon-qiehuan" @click="toggleMoney"></div>
              <div class="rate flex-between">
                <span class="left">
                  <el-dropdown @command="handleCommandRateCur">
                    <div class="el-dropdown-link flex items-center">
                      <img :src="$smallImage(curtype.icon)" class="type-icon" v-if="curtype && curtype.icon"/>{{curtype.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in nationalData.moneytypes" :key="item.key" :command="item.key">{{ item.name}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <span class="right">{{curtype.symbol}}{{curresult.curmoney ? curresult.curmoney.toFixed(2) : ''}}</span>
              </div>
            </div>
            <div style="color: #909090;font-size: 13px;"><template v-if="curresult && curresult.datetime">{{$t('更新于{t}').replace('{t}', curresult.datetime)}}，</template>{{$t('数据仅供参考，交易时以银行柜台成交价为准。')}}</div>
          </div>
          <div slot="reference" class="cursor-pointer"><span class="iconfont icon-huishuai"></span>{{ $t("汇率查询") }}</div>
        </el-popover>
        <span class="v-line"></span>
        <router-link class="cursor-pointer" :to="{ path: '/help/callus', query: { tag: 'callus' } }">{{ $t("联系我们") }}
        </router-link>
        <span class="v-line"></span>
        <router-link class="cursor-pointer" :to="{ name: 'serveState', query: { tag: 'trade_rule' } }">{{ $t("帮助") }}
        </router-link>
        <span class="v-line"></span>
        <el-dropdown @command="handleCommandLang" class="pr-4 text-hex-333333 pt-2px">
          <span class="el-dropdown-link">
            {{ $t("语言") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in nationalData.langs" :key="item.key" :command="item.value"
              :disabled="!item.enable" :class="{ dropActive: nationalSetting.lang == item.value }">{{ item.name
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommandMoney" class="pt-2px text-hex-333333">
          <span class="el-dropdown-link">
            {{ $t("币种") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in nationalData.moneytypes" :key="item.key" :command="item.key"
              :disabled="item.disabled" :class="{ dropActive: nationalSetting.moneytype == item.key }">{{ item.name
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-dropdown @command="handleCommandZh" class="pt-2px text-hex-333333">
          <span class="el-dropdown-link">
            {{ $t("简体/繁体") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="hans">中文简体</el-dropdown-item>
            <el-dropdown-item command="cn">中文繁体</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>  -->
      </div>
    </div>
    <div class="h-26" :class="{ whiteSpace: !topSearchBar }"></div>
    <div id="searchbar" class="flex items-center justify-center w-full" :class="{ navBarWrap: topSearchBar }">
      <div class="flex-center px-2 h-26 box-border w-87.5rem">
        <router-link to="/">
          <img class="logo" src="https://cdn-qn-hours.inruan.com/hours/X1/20260122/FoA3HnHX5fROazV-Y_hszetv2jBH.png" alt />
        </router-link>
        <div class="flex-center input-wrap hover-high-border">
          <el-select v-model.number="form.classify_id" class="classify el-none-boder w-25" :placeholder="$t('请选择')"
            style="border: none">
            <el-option v-for="item in classify_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-input v-model="form.keyword" :placeholder="$t('请输入关键词')" class="flex-1 input-keyword el-none-boder input"
            @keyup.enter.native="startSearch" />
          <el-button type="primary" class="el-none-radius" @click="startSearch">
            <span class="iconfont icon-sousuo"></span>
          </el-button>
        </div>
        <el-button type="primary"   @click="gotoFast">{{ $t("快速加购") }}</el-button>
        <div class="top ">
          <router-link  @click.native="handleClick" to="">
            <div >
              <el-badge :value="user.message.total" @click.native="$goTo('/mine/message/')">
                <p class="iconfont icon-tongzhi"></p>
                <p>{{ $t("消息") }}</p>
              </el-badge>
            </div>
          </router-link>
          <router-link to="/mine/order/origin" @click.native="handleClick" >
            <div>
              <p class="iconfont icon-dingdan"></p>
              <p>{{ $t("订单") }}</p>
            </div>
          </router-link>
          <router-link to="/mine/cart/" @click.native="handleClick">
            <div v-popover:popover>
              <p class="iconfont icon-cart"></p>
              <p>{{ $t("购物车") }}</p>
            </div>
          </router-link>
          <el-popover ref="popover" placement="top-end" :title="$t('最新加入的商品')" width="25rem" trigger="hover"
            :disabled='popoverDisable'>
            <div class="space-y-8">
              <div class="max-h-120 overflow-y-auto divide-y-1">
                <div v-for="item in cart_info" :key="item.id">
                  <Cart :data="item" @del-cart="delCart"></Cart>
                </div>
              </div>
              <div class="flex justify-between items-center" v-if="cart_info">
                <p>
                  {{ $t("共") }}
                  <span>{{ cart_info.length }}</span>
                  {{ $t("件商品") }}
                </p>
                <router-link to="/mine/cart/" @click.native="handleClick">
                  <el-button type="primary" size="default">
                    {{
                      $t("进入购物车")
                    }}
                  </el-button>
                </router-link>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <img src="https://cdn-qn.huaeb.com/sellmall/Uuq15Xhd/20250224/FoaZtFvWOl9FvwZ2EDQXL3rmObdy.png"  v-if="routerPath === '/cusprocess'">
    <div id="main-wrap" class="container w-87.5rem mt-2">
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive> -->
      <router-view></router-view>
    </div>
    <div id="bottom" v-if="!helpCenterTag" >
      <div class="w-87.5rem container">
        <div class="partner-logo">
           <span>{{ $t("合作伙伴") }}</span>
           
           <div v-for="(logo, index) in nationalSetting.logos" :key="index">
            <img :src="logo.img">
            <!-- {{logo}} -->
           </div>
           
        </div>
        <div class="py-24 flex flex-nowrap  flex-between">
          <Icon icon="icon-pifa">
            <template #title>{{ $t("批发中心") }}</template>
            <template #detail>
              {{ $t("区域中心仓和国家仓") }}
              <br />
              {{ $t("并行运作") }}
              <!-- {{ $t("我们公司坐落于昆明") }}
              <br />
              {{ $t("中国80%的鲜花来自云南昆明") }} -->
            </template>
          </Icon>
          <Icon icon="icon-zhonglei">
            <template #title>{{ $t("种类丰富") }}</template>
            <template #detail>
              <!-- {{ $t("我们拥有") }}
              <br />
              {{ $t("300多个不同品类的鲜花供您选择") }} -->
              {{ $t("300多个不同品类的鲜花") }}
              <br />
              {{ $t("供您选择") }}
            </template>
          </Icon>
          <!-- <Icon icon="icon-kuaguo">
            <template #title>{{ $t("跨国购物") }}</template>
            <template #detail>
              {{ $t("我们发往10个国家") }}
              <br />
              {{ $t("和地区，我们网站有5种语言") }}
            </template>
          </Icon> -->
          <Icon icon="icon-anquan">
            <template #title>{{ $t("安全付款") }}</template>
            <template #detail>
              {{ $t("平台担保") + "" + $t("资金安全") }}
              <br />
              {{ $t("花材品质保障") + ' ' + $t("售后无忧") }}
            </template>
          </Icon>
          <Icon icon="icon-bangzhu">
            <template #title>{{ $t("帮助中心") }}</template>
            <template #detail>
              
              {{ $t("提供优质购物体验") }}
            </template>
          </Icon>
          <Icon icon="icon-kongyun">
            <template #title>{{ $t("精准物流") }}</template>
            <template #detail>
              {{ $t("顺畅的空运、海运、陆上冷链") }}
              <br />
              {{ $t("与同城到店配送") }}
              <!-- {{ $t("花材打包空运，缩短") }}
              <br />
              {{ $t("物流时间，减小花材损耗成本") }} -->
            </template>
          </Icon>
        </div>
      </div>
      <el-divider class="mt-0"></el-divider>
      <div class="min-w-87.5rem flex justify-start items-start container">
        <!-- <div class="text-left mr-12 asd space-y-2">
          <p id="service" class="!text-base font-bold">{{ $t("帮助中心") }}</p>
          <router-link :to="{ name: 'helpCenter', query: { tag: item.tag } }" v-for="item in helpLink" :key="item.tag">
            {{ $t(item.title) }}</router-link>
        </div> -->

        <div class="text-left asd space-y-2 mr-12">
          <p id="guide" class="!text-base font-bold">{{ $t("购物指南") }}</p>
          <router-link :to="{ name: 'serveState', query: { tag: item.tag } }" v-for="item in serveLink" :key="item.tag">
            {{ $t(item.title) }}</router-link>
        </div>
        <div class="text-left asd space-y-2">
          <p id="guide" class="!text-base font-bold">{{ $t("关于我们") }}</p>
          <router-link :to="{ name: item.name, query: { tag: item.tag } }" v-for="item in aboutUsLink" :key="item.tag">
            {{ $t(item.title) }}</router-link>
        </div>
        <div class="text-left asd ml-15 space-y-2" @click="$goTo('/help/feedback?tag=feedback')">
          <p id="guide" class="!text-base font-bold cursor-pointer">{{ $t("意见反馈") }}</p>
        </div>
        <div class="ml-auto space-y-2">
          <!-- <p id="guide" class="font-bold cursor-pointer" @click="$goTo('/help/callus?tag=callus')">{{ $t("联系我们") }}</p>
          <p class="text-2xl">+86-400-610-1001</p>
          <p class="text-sm">08:00-08:00({{ $t("24小时热线") }})</p> -->
          <p>
            <el-button size="medium" @click="goFeedback">
              <span class="iconfont icon-liuyan transform scale-76 inline-block translate-y-2px mr-1"></span>
              {{ $t("留言反馈") }}
            </el-button>
          </p>
        </div>

        <el-divider direction="vertical" class="mx-16 h-40 mb-6"></el-divider>
        <div class="flex space-x-12">
          <!-- <div>
            <img class="container w-28" src="https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230410/FsKbPbe1RlAvnpXxkJvrEVvdzN8Q.png"
              alt />
            {{ $t("关注我们") }}
          </div> -->
          <div>
            <img class="container w-28" :src="$smallImage('https://irutils.inruan.com/utils/qrcode?text=https://int.huaeb.com/app/download.html&logo=https://cdn-qn-hours.inruan.com/hours/X1/20260122/FlAQaULCKe2OTN1LkKBsoDZ5IUsC.png')"
              alt />
            {{ $t("APP下载") }}
          </div>
        </div>
      </div>
    </div>
    <div id="foot" class="bg-dark-50 h-10 w-full flex-center">
      <!-- <div class="container w-87.5rem text-left text-light-900 text-xs">
        {{ $t('copyright © 2021 昆明花易宝科技有限公司版权所有 滇IPC备12345678954号滇公网安备1326547489号 技术支持：银软科技') }}
      </div> -->
    </div>
    <el-dialog :visible.sync="isAlertAddress" destroy-on-close width="51rem" title append-to-body
      :before-close="handleClose">
      <div>
        <p style="color:red">{{ $t("温馨提示：您填好了收货地址后,系统才能根据您填的收货地址给您展示对应区域内的商品哦！") }}</p>
        <p style="color:red;font-size:12px">{{ $t("注意：如果您填好了收货地址后，首页还是没有显示商品，说明您所填的收货地址对应的区域中没有商品出售") }}</p>
      </div>
      <AddAddress @closeAddress="closeAddress"></AddAddress>
    </el-dialog>
    <div class="livechat-girl" @click="talkToService" v-if="false">
      <img class="girl" src="https://cdn-qn.huaeb.com/sellmall/X1/20221115/Fn4yMJlrmZ_6Kq1KLy6DMeVffnQY.png">
      <div class="livechat-hint rd-notice-tooltip rd-notice-type-success rd-notice-position-left ">
        <div class="rd-notice-content"></div>
      </div>
    </div>
    <div id="chat"
      style="	position: fixed;
                                                                                                                                                                          left: 50%;
                                                                                                                                                                          top: 50%;
                                                                                                                                                                          width: 505px;
                                                                                                                                                                          height: 450px;
                                                                                                                                                                          margin-top: -250px;
                                                                                                                                                                          margin-left: -250px;
                                                                                                                                                                          border: 2px solid #2EC46B;
                                                                                                                                                                          border-radius: 4px;
                                                                                                                                                                          background-color: white;
                                                                                                                                                                          z-index: 999"
      v-if="showChatBox">
      <div
        style="padding:5px 15px;
                                                                                                                                                                          background-color: #2EC46B;
                                                                                                                                                                          color: white;
                                                                                                                                                                          font-size: 14px;
                                                                                                                                                                          line-height: 24px;
                                                                                                                                                                          height: 28px;">
        <div style="float: left;display: inline-block">{{ $('在线沟通') }}</div>
        <div id="chat_close" style="float:right;display: inline-block;cursor:pointer" @click="closeChatBox">关闭</div>
      </div>
      <iframe ref="ifra" style="height: 415px;width: 500px" src="" frameborder="0"></iframe>

    </div>
    <AddrTable :show="showAddrLists" @modifyAddr="modifyAddr" @close="showAddrLists = false"></AddrTable>
    <el-dialog :visible.sync="erweima.show" destroy-on-close center width="35rem" @close="handleEwmDialog">
      <div class="flex-center flex-col">
        <img :src="$normalImage(erweima.img)" />
        <span v-if="erweima.tips">{{ erweima.tips }}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Icon from "@/components/home/icon.vue";
import Cart from "/src/components/home/cart.vue";
import Login from "@/components/home/login.vue";
import AddAddress from "@/components/mine/addAddress.vue";
import AddrTable from "./components/mine/addrTable.vue";
import { $apiurl, $LANGTAB } from "@/config.js";
import {
  $setStorage,
  $getStorage,
  // $getNavigationBarTitle
} from "@/common/common.js";
import axios from "axios";

import {
  reactive,
  watchEffect,
  computed,
  ref,
  watch,
  onMounted
} from "@vue/composition-api";
import { compose, defaultTo } from "ramda";
import { $smallImage } from "./common/utils";
import router from "./router";
import { $t } from "./common/common";

export default {
  components: { Icon, Cart, Login, AddAddress, AddrTable },

  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters.user);
    const getUserInfo = async () => {
      const res = await ctx.root.$callapi("user/getUserInfo");
      ctx.root.$store.commit("SET_USER", res.data);
    };

    const address = ref()
    const getLockAddress = async () => {
      let res = await ctx.root.$callapi('user/getAddress', {
        aid: user.value?.user_lock_address
      })
      if (res.code == 0 && res.data) {
        address.value = res.data
        ctx.root.$store.commit('SET_LOCKADDRESS', res.data)

      }
    }
    const setLockAddress = async (aid) => {
      let res = await ctx.root.$callapi('user/setLockDefaultAddress', {
        aid
      })
      if (res.code == 0 && res.data) {
        ctx.root.$store.commit('SET_ADDRESS', res.data)
        ctx.root.$store.commit('SET_LOCKADDRESS', address.value)

      }
    }
    const showAddrLists = ref(false)
    // 获取后购物车信息
    const cart_info = computed(() => {
      return ctx.root.$store.state.cart.cart;
    });


    const loadData = async () => {
      await getUserInfo()
      if (user.value.id) {
        if (user.value?.user_lock_address) {
          await getLockAddress()
        } else {
          ctx.root.$toast(ctx.root.$t('请先选择地址'))
          showAddrLists.value = true
        }
        const cart_message = (await ctx.root.$callapi("trade/getMyCartList", {wh:'origin'})).data
        ctx.root.$store.commit("SAVE_CART", cart_message);

      }
    }
    loadData()

    const modifyAddr = (val) => {
      address.value = val
      showAddrLists.value = false
      setLockAddress(val.id)
    }

    const showAddr = () => {
      if (ctx.root.$route.name == 'Home') {
        showAddrLists.value = true
      } else {
        ctx.root.$toast(ctx.root.$t('请返回首页进行地址选择'))
      }
    }

    const gotoFast = () => {
      ctx.root.$router
        .push({
          name: "flightDetail",
          query: { classify_id: ctx.root.$route.query.classify_id || 0 },
        })
        .catch(() => { });
    };
    const helpCenterTag = ref();
    watchEffect(() => {
      helpCenterTag.value = ctx.root.$route.query.tag;
    });
    const classify_list = ref()
    const getClassifyList = async () => {
      let res = await ctx.root.$callapi('pre/getClassifyList')
      if (res.code == 0 && res.data) {
        classify_list.value = res.data.items
      }
      classify_list.value.unshift({ id: 0, name: ctx.root.$t('全部') })

    }
    getClassifyList()
    watch(() => user.value.user_lock_address, async () => {
      await getClassifyList()
    })
    const form = reactive({
      keyword: null,
      classify_id: 0,
      page: 1,
    });
    const startSearch = () => {
      ctx.root.$router
        .push({
          name: "Product",
          query: form,
        })
        .catch(() => { });
    };
    watchEffect(() => {
      form.classify_id = compose(
        defaultTo(0),
        Number
      )(ctx.root.$route.query.classify_id);
    });

    const loginOut = async () => {
      ctx.root.$doing();
      let res = await ctx.root.$callapi("user/logout");
      ctx.root.$done();
      if (res.code == 0) {
        ctx.root.$goto("/");
        window.location.reload()
      }
    };

    // 删除购物车
    const delCart = async (pid) => {
      ctx.root.$store.commit("REMOVE_CART", pid);
      try {
        await ctx.root.$callapi("trade/editWithCart", { pid, quantity: -1 });
      } catch (e) {
        return e;
      }
    };

    //留言反馈
    const goFeedback = () => {
      ctx.root.$router.push({ name: "feedback", query: { tag: "feedback" } });
    };
    //帮助中心
    const helpLink = ref([
      { title: "常见问题", tag: "help" },
      { title: "订单问题", tag: "order_issue" },
      { title: "物流问题", tag: "lgs_issue" },
      { title: "优惠券问题", tag: "cp_issue" },
      { title: "退货与售后问题", tag: "after_sale" },
    ]);
    const serveLink = ref([
      { title: "交易规则", tag: "trade_rule" },
      { title: "用户使用协议", tag: "service" },
      { title: "隐私政策", tag: "privacy" },
      { title: "免责声明", tag: "notice" },
    ]);
    const aboutUsLink = ref([
      {
        title: "关于花易宝",
        name: "Hiflowers",
        tag: "Hiflowers",
      },
      { title: "新闻资讯", name: "news", tag: "news" },
      // {
      //   title: "意见反馈",
      //   name: "feedback",
      //   tag: "feedback",
      // },
      // {
      //   title: "联系我们",
      //   name: "callus",
      //   tag: "callus",
      // },
    ]);

    // el-dialog关闭时会触发的方法
    const handleClose = (done) => {
      const tip = "如果不填写地址,那么首页将不会展示商品"
      ctx.root.$confirm(tip)
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
    const popoverDisable = computed(() => {
      let arr = ['flightDetail', 'store']
      return arr.includes(ctx.root.$route.name)
    })
    // 登录
    const type = ref('login')
    //  下载app 二维码
    const erweima = reactive({
      show: false,
      tips: '',
      img: ''
    });
    const getErweima = (...args) => {
        erweima.img= args[0];
        // erweima.show = true;
        erweima.tips = args[1]
        checkEwmFirstShow();
    };
    //  弹出app 下载二维码
    setTimeout(() => {
      getErweima('https://irutils.inruan.com/utils/qrcode?text=https://int.huaeb.com/app/download.html&logo=https://cdn-qn-hours.inruan.com/hours/X1/20260122/FlAQaULCKe2OTN1LkKBsoDZ5IUsC.png',ctx.root.$t('扫码下载app，买花更方便'))
    }, 1500)
    const checkEwmFirstShow = () => {
      const storageKey = 'autoDialogLastShownDate';
      const lastShownDate = localStorage.getItem(storageKey);
      const today = new Date().toDateString();

      // 如果从未显示过或上次显示不是今天，则显示弹窗
      if (!lastShownDate || lastShownDate !== today) {
        erweima.show = true
        localStorage.setItem(storageKey, today);
      }
    }
    const handleEwmDialog = () => {
        erweima.show = false
    }

    //  start 汇率查询
    

    // end
    return {
      classify_list,
      startSearch,
      form,
      loginOut,
      cart_info,
      delCart,
      goFeedback,
      helpLink,
      serveLink,
      aboutUsLink,
      helpCenterTag,
      gotoFast,
      handleClose,
      // msgCount,
      showAddrLists,
      modifyAddr,
      // user
      address,
      showAddr,
      popoverDisable,
      type,
      erweima,
      handleEwmDialog 

    };
  },

  data() {
    return {
      nationalData: {
        areas: [],
        langs: [],
        moneytypes: [],
      },
      // nationalSetting: { lang: "zh_CN", moneytype: "CNY", area: 1 },
      nationalSetting: { lang: "zh_CN", moneytype: "CNY", area: 1, logos: [] },
      rawNationalSetting: null,
      sign_dialog: false,
      user: this.$store.state.user.user,
      topSearchBar: false,
      isAlertAddress: false,
      showChatBox: false,
      moneyForm: {
				money: '1',
				maintype: 'CNY',
				curtype: ''
			},
      curresult: {},
      
    };
  },
  // computed: {
  //   ...mapGetters(["user"]),
  // },
  computed: {
		maintype() {
			let v = this.moneyForm.maintype
			return this.nationalData.moneytypes?.find(r => r.key == v) || {}
		},
		curtype() {
			let v = this.moneyForm.curtype
			return this.nationalData.moneytypes?.find(r => r.key == v) || {}
		},
    routerPath(){
      return this.$route.path
    }
	},
  async mounted() {
    window.addEventListener("scroll", this.watchScroll);
    let res = await this.updateLocalNationalData()
    res?.langs.map(item => {
      let arr = ['zh_CN', 'en', 'th','lo']
      if (!arr.includes(item.value)) {
        item.disabled = true
      }
    })
    // res?.moneytypes.map(item => {
      // let arr = ['CNY', 'USD', 'THB','LAK']
      // if (!arr.includes(item.key)) {
      //   item.disabled = true
      // }
    // })
    this.nationalData = res
    this.nationalSetting = await this.loadNationalData();
    this.moneyForm.curtype = this.$getMoneyType()
    this.updateMoney()

    // window.localStorage.viewcount = (window.localStorage.viewcount || 0) + 1;
    // if (window.localStorage.viewcount == 1) {
    //   this.nationalSetting.lang = 'en';
    //   this.$setLang(this.nationalSetting.lang);
    //   this.saveSetting(this.nationalSetting, true);
    //   return;
    // }


    this.rawNationalSetting = JSON.stringify(this.nationalSetting);

  },
  watch: {
    nationalSetting: {
      deep: true,
      handler() {

        if (
          this.rawNationalSetting &&
          this.rawNationalSetting != JSON.stringify(this.nationalSetting)
        ) {
          this.$setLang(this.nationalSetting.lang);
          this.$setMoneyType(this.nationalSetting.moneytype);
          this.saveSetting(this.nationalSetting);
        }
      },
    },
  },
  methods: {
    handleCommandLang(val) {
      this.nationalSetting.lang = val;
    },
    handleCommandMoney(val) {
      this.nationalSetting.moneytype = val;
    },
    handleCommandZh(val){
      let bodyDoc = document.body
      if(val == "hans"){
        // bodyDoc.removeProperty('font-variant-east-asian')
        bodyDoc.style.setProperty('font-variant-east-asian', 'simplified')
        // console.log("hans11111")
      }else if(val == "cn"){
        // console.log("cn22222")
        bodyDoc.style.setProperty('font-variant-east-asian', 'traditional')
      }
    },
    async handleCommandRateMain(val){
      this.moneyForm.maintype = val
      this.updateMoney()
  
    },
    async handleCommandRateCur(val){
      this.moneyForm.curtype = val
      this.updateMoney()
    },
    async updateMoney() {
				this.curresult = null
				let mt = this.maintype
				let ct = this.curtype
				if (!mt || !ct)
					return
				let r1 = mt.rate || 1
				let r2 = ct.rate || 1
				if (mt.reverse) {
					r1 = 1 / r1
				}
				if (ct.reverse) {
					r2 = 1 / r2
				}
				this.curresult = {
					curmoney: r2 * this.moneyForm.money / r1,
					datetime: ''
				}
			},
    showRate(reverse){
      let mt = this.maintype
				let ct = this.curtype
				if (!mt || !ct)
					return
				let r1 = mt.rate || 1
				let r2 = ct.rate || 1
				if (mt.reverse) {
					r1 = 1 / r1
				}
				if (ct.reverse) {
					r2 = 1 / r2
				}
        if(reverse){
          return (r1 * 1/r2)?.toFixed(2) || '--'
        }
        return (r2 * 1/r1)?.toFixed(2) || '--'
    },
    handleClick() {
      this.sign_dialog = !this.$route.query.isLogin;
    },
    hclick() {
      this.sign_dialog = false;
    },
    closeAddress() {
      this.isAlertAddress = false;
      location.reload();
      // console.log("")
    },

    closeChatBox() {
      this.showChatBox = false
    },

    async talkToService() {
      if (this.showChatBox == false) {
        this.showChatBox = !this.showChatBox;
        const res = await this.$callapi("getiChatData", { "target": "service" })
        console.log("getiChatData:", res)
        this.$nextTick(() => {
          if (res.data) {
            const data = res.data
            // var source=window.location.href;
            // var ichat_appid=data.ichat_appid
            // var ichat_url=data.ichat_url
            // var token=data.param.token
            // var target=data.param.target

            console.log("iframe_url:", data.url)
            this.$refs.ifra.src = data.url
          }

        })
      } else {
        this.showChatBox = !this.showChatBox;
      }

    },
    // watchScroll() {
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   this.topSearchBar = scrollTop > 50 ? true : false;
    // },

    async updateLocalNationalData(force) {
      let nd = await this.$lazy("NationalData", force);
      let exMap = {};
      nd.moneytypes.forEach((mt) => {
        exMap[mt.key] = mt;
      });
      nd.exMap = exMap;
      $setStorage("LocalNationalData", nd);
      return nd;
    },
    // 加载区域化数据
    async loadNationalData() {
      let lt = $getStorage("LANGTAB");
      if (lt) {
        Object.assign($LANGTAB, lt);
      }
      // console.log(lt);
      let r = await this.$callapi("getNationalSetting");
      if(r?.data?.lang){
					this.$setLang(r.data.lang)
				}
      await this.loadLangTab();
      // if (!$LANGTAB.time || (Date.now() - $LANGTAB.time) > (60 * 1000)) {
      // 	await this.loadLangTab();
      // }
      return r.data;
    },

    // 加载词表
    async loadLangTab(refresh) {
      return new Promise((resole, reject) => {
        let lang = this.$getLang() || "zh_CN";
        let setTable = function (table) {
          $LANGTAB.lang = lang;
          $LANGTAB.table = table;
          $LANGTAB.time = Date.now();
          $setStorage("LANGTAB", $LANGTAB);
          if (refresh) {
            window.location.reload();
          }
          resole($LANGTAB);
        };
        if (lang == "zh_CN") {
          // 主语言，无效加载
          setTable({});
        } else {
          let url =
            $apiurl + "/resource/langtab-" + lang + ".json?_=" + Date.now();
          axios
            .get(url)
            .then((res) => {
              if (res && res.data) {
                setTable(res.data);
              }
            })
            .catch((error) => { });
        }
      });
    },
    async saveSetting(d, is_auto=false) {
      this.$doing();
      // console.log("d:", d)
      d.is_auto = is_auto
      await this.$callapi("setNationalSetting", d);
      this.$done();
      this.loadLangTab(true);
      //window.location.reload()
    },
    toggleMoney() {
			Object.assign(this.moneyForm, {
				curtype: this.moneyForm.maintype,
				maintype: this.moneyForm.curtype,
			})
		}
   

  },
};

</script>

<style lang="scss">
@import "./style/styles.scss";

html {
  font-size: clamp(12px, 1vw, 16px);
}

body {

    font-variant-east-asian: simplified;

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  // overflow-y: overlay;
  // height: 100vh;
  #tophead {
    background: $main-gray;
    padding: 5px 0;
    font-size: 14px;

    .v-line {
      height: 10px;
      margin: 0 10px;
    }

    .img-vip {
      height: 16px;
      border-radius: 3px;
    }
  }

  .navBarWrap {
    position: fixed;
    top: 0;
    z-index: 999;
    height: 50px;
  }

  .whiteSpace {
    display: none;
  }

  #searchbar {
    background: white;
    z-index: 999;

    .logo {
      @apply w-170px;
    }

    .input-wrap {
      border: 2px solid $main-color;
      border-radius: 5px;
      flex-grow: 1;
      height: 40px;
      margin-left: 100px;
      margin-right: 0.375rem;
      overflow: hidden;

      .btn-search {
        height: 100%;
        padding: 0 10px;
      }

      .input-keyword {
        font-size: 16px;
        padding: 0 10px;
        border: none;
        background: none;
        outline: none;

        &:focus {
          border: none;
        }
      }
    }
  }

  #main-wrap {
    margin-top: $panel-margin;
  }

  #bottom {
    margin-top: $panel-margin;
    width: 100%;
    background-color: #fff;
    @apply flex-center flex-col;
    // background-color: pink;
  }

  button {
    outline: none;
  }

  .asd>a {
    @apply text-sm block;
  }

  .asd>p {
    @apply text-sm;
  }

  .top {
    @apply flex justify-end mt-4;

    div {
      @apply text-gray-600 hover: (text-main) inline-block text-sm ml-10;

      &>.iconfont {
        @apply transform scale-130 -translate-y-5px;
      }
    }
  }

  .chhh {
    .el-input__inner {
      @apply bg-mainGray;
    }
  }
}

.dropActive {
  background: rgba(232, 248, 239);
}

.input .el-input__inner::-webkit-input-placeholder {
  @apply text-sm;
}

.livechat-girl {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid darkturquoise;
  position: fixed;
  bottom: 30px;
  right: 40px;
  box-shadow: 0 5px 10px 0 rgb(35 50 56 / 30%);
  z-index: 700;
  cursor: pointer;
  transition: all 1s cubic-bezier(.86, 0, .07, 1);
}

.livechat-girl .girl {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 50;
}

.partner-logo {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
}

.partner-logo span{
  color: #333333;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 18px;
  margin-top: 53px;
}

.partner-logo img{
  width: 153px;
  height: 67px;
  margin-top: 34px;
  margin-left: 15px;
}
.rate-box{
   .rate{
      width:100%;
      height:51px;
      border:1px solid #E4E4E4;
      margin:10px 0;
      .type-icon{
        width:30px;
        height:20px;
        margin-right:5px;
      }
      
      span{
        display:inline-block;
        width:50%;
        height:48px;
        line-height:48px;
        padding:0 10px;
        input{
          width:30%;
          text-align:right;
          outline: none;
        }
      }
      .left{
        background:#F6F6F6;
      }
      .right{
        border-left:2px solid #E4E4E4;
        text-align:right;
      }
   }
}
</style>
